import { render, staticRenderFns } from "./ChipCustomizeCloseClearChipIcon.vue?vue&type=template&id=1e7972b2&"
import script from "./ChipCustomizeCloseClearChipIcon.vue?vue&type=script&lang=js&"
export * from "./ChipCustomizeCloseClearChipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports